<div class="navbar row justify-content-center">
    <div class="col-11">
        <button *ngIf="calendar" (click)="back()" class="btn btn-outline-primary"><i class="fa fa-arrow-left fa-fw"></i> Back</button>

        <button id="signout" (click)="signOut()" class="btn btn-outline-danger">Sign out</button>
    </div>
</div>